import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { ResolvedAccount } from './response';
import type { ResolveAccountPayload } from './payload';

export const resolveAccount = async (payload: ResolveAccountPayload) => {
  const response = await axiosInstance.post<RequestResponse<ResolvedAccount>>(
    endpoints.resolveAccount,
    payload
  );
  return response.data.data;
};
